/**
 * Parses the chat payload and returns the chat body object.
 *
 * @param {Object} payload - The payload containing chat data.
 * @param {Object} payload.data - The data object.
 * @param {string} payload.data.data - The chat body as a JSON string.
 * @param {string} payload.data.title - The title of the message.
 * @param {string} payload.from - The sender's identifier.
 * @param {string} payload.priority - The priority of the message.
 * @param {string} payload.fcmMessageId - The FCM message ID.
 * @returns {{
 *   ticket: {
 *     id: number,
 *     status: string,
 *     lastMessage: string,
 *     contactId: number,
 *     userId: number,
 *     created_at: string,
 *     updated_at: string,
 *     whatsappId: number,
 *     isGroup: number,
 *     unreadMessages: number,
 *     queueId: number,
 *     toOPerDate: string,
 *     toBotCal: string|null,
 *     closedTime: string|null,
 *     nuevo: number,
 *     ControlOrdenBotMensajes: number,
 *     contactNumber: string,
 *     typeTicketId: number,
 *     status_bot: string|null
 *   },
 *   last_message: string,
 *   type: number
 * }} The parsed chat body object.
 */
export const getChatBody = (payload) => {
  const { data } = payload;
  const bodyParsed = JSON.parse(data.data);
  if (typeof bodyParsed === "string") return bodyParsed;
  return bodyParsed;
};
